<template>
  <notification icon="fa-cookie-bite" type="is-info" @delete="close">
    <p>
      Niniejsza strona używa plików cookies, aby zapewnić najlepszy komfort
      korzystania z niej. Pozostając tutaj, akceptujesz
      <router-link to="/privacy" @click.native="clickLink"
        >naszą politykę prywatności</router-link
      >.
    </p>
  </notification>
</template>

<script>
import Notification from "./Notification";

export default {
  name: "cookies-notification",

  components: {
    Notification
  },

  props: {
    beforeClose: Function
  },

  methods: {
    clickLink() {
      this.$immediatelyScrollToTop();
      this.close();
    },

    close() {
      this.beforeClose();
      this.$emit("delete");
    }
  }
};
</script>

<style></style>
